import api from './index'
import { BookingDataProps, BookingPricesProps } from '../interfaces'

export const getIpInfo = () => {
  return api({
    method: 'get',
    url: '/activity-service/geo-ip/location',
  })
}

export const createReservation = (data: BookingDataProps) => {
  return api({
    method: 'post',
    url: '/reservation-service/reservation',
    data,
  })
}

export const getPricesBooking = (data: BookingPricesProps, cancelParams?: any) => {
  let optionsApi: any = {
    method: 'post',
    url: '/listing-service/v2/calendar/price',
    data,
  }
  if (cancelParams) optionsApi = { ...optionsApi, ...cancelParams }
  return api(optionsApi)
}

export const stripePaymentBooking = (reservationId: string, billingDetail?: any) => {
  let data = { reservationId }
  if (billingDetail) data = { ...data, ...billingDetail }
  return api({
    method: 'post',
    url: '/paygate-service/stripe/payment',
    data,
  })
}

export const getPropertyDetail = (hostId: string, listingId: string | number) => {
  return api({
    method: 'get',
    url: `/listing-service/v2/property/${hostId}/${listingId}`,
  })
}

/**
 * Returns array availability for each day.
 *
 * @param {string} hostAddress The wallet address of host
 * @param {string} listingId The hostaway id
 * @param {string} startDate Date from, format YYYY-MM-DD.
 * @param {string} endDate Date to, format YYYY-MM-DD.
 * @return {Promise} array availability for each day.
 */
export const getCalendar = (hostAddress: string, listingId: string, startDate: string, endDate: string) => {
  return api({
    method: 'get',
    url: '/listing-service/calendar',
    params: { hostAddress, listingId, startDate, endDate, currency: 'USD' },
  })
}

export const getRateCurrency = () => {
  return api({
    method: 'get',
    url: 'paygate-service/currency/rates',
  })
}
export const getTokenContract = (chainId: string) => {
  return api({
    method: 'get',
    url: `/sc-service/token/${chainId}`,
  }).then((res) => res.data)
}
export const getConvertCurrency = (value: number | string, base: string, targets = 'usd') => {
  return api({
    method: 'get',
    url: '/paygate-service/currency/convert',
    params: { value, base, targets },
  }).then((res) => res.data)
}
export const getPaymentMethod = (hostAddress: string) => {
  return api({
    method: 'get',
    url: '/paygate-service/payment/method/booking',
    params: { hostAddress },
  })
}

export const getBusinessInfor = async (hostAddress?: string) => {
  return api({
    method: 'get',
    url: hostAddress
      ? `/integration-service/host/contact/${hostAddress.toLowerCase()}`
      : `/integration-service/host/contact`,
  }).then((res) => res.data)
}
